import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { HardHat } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        if (data?.access_status) {
          navigate(`/zugang/status?s=${data.access_status}`, { replace: true });
          return;
        }
        setUser(data);
        navigate("/dashboard", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
      <div className="h-12 w-12 rounded-xl bg-primary flex items-center justify-center">
        <HardHat className="h-6 w-6 text-white" />
      </div>
      <div className="animate-spin h-6 w-6 rounded-full border-2 border-primary border-t-transparent" />
      <p className="text-slate-500">Anmeldung wird verarbeitet…</p>
    </div>
  );
}
